export default __webpack_public_path__ + "static/media/kitchen5-afterB-1440w.0439cbbf.webp";